import {inject, Injectable} from '@angular/core';
import {UserPreferencesService} from "../../../../services/user-preferences.service";
import {ColumnProfile, UserPreferences} from "../../../../types/user-preferences.types";

@Injectable({
  providedIn: 'root'
})
export class SettingsTableModalService {
  private userPreferencesService: UserPreferencesService = inject(UserPreferencesService);

  public getSelectedProfile(): string {
    const profiles = this.userPreferencesService.getUserPreferences()?.columnProfiles;
    return profiles?.find(i => i.isActive)?.profileName || '';
  }

  public getProfileSelectData(): Array<string> {
    const profiles = this.userPreferencesService.getUserPreferences()?.columnProfiles;

    return profiles ? profiles.map(i => i.profileName) : [];
  }

  public updateActiveProfile(selectedProfile: string) {
    const userPreferences: UserPreferences | null = this.userPreferencesService.getUserPreferences();
    const profiles = userPreferences?.columnProfiles;
    profiles?.forEach(profile => {
      profile.isActive = profile.profileName === selectedProfile;
    });

    profiles && this.userPreferencesService.saveUserPreferences({ columnProfiles: profiles });
  }

  public getHiddenColumnsByActive(): Array<string> {
    const userPreferences: UserPreferences | null = this.userPreferencesService.getUserPreferences();
    const profiles = userPreferences?.columnProfiles ?? [];
    const activeProfile = profiles.find(i => i.isActive);
    const hiddenColumnKeys: Array<string> = activeProfile?.hiddenColumnKeys ?? [];

    return hiddenColumnKeys?.length ? hiddenColumnKeys : [];
  }

  public deleteColumnProfile(profileName: string): Array<ColumnProfile> | undefined {
    const newColumnProfiles = this.userPreferencesService.getUserPreferences()?.columnProfiles?.filter(i => i.profileName !== profileName);
    this.userPreferencesService.saveUserPreferences({ columnProfiles: newColumnProfiles });
    return newColumnProfiles;
  }
}
